import { IUser } from "authentication/domain/IUser";
import { useCallback, useEffect, useState } from "react";
import UpdateUserPasswordModal from "./UpdatePasswordModal";
import userImage from "Dashboard/images/user.jpg";
import { authServices } from "authentication/services/auth.service";
// import { IUserRole } from "authentication/domain/IUserRole";
import { debounce } from "lodash";
import UploadPhotoModal from "./UploadPhotoModal";
import { ImageUploadType } from "Dashboard/domain/ImageUploadType";
import EmployeeSelectCustom from "./EmployeeSelectCustom";

interface IProps {
  setClickOutsideActive: Function;
  currentUser: IUser;
}

const UserSettings = ({ setClickOutsideActive }: IProps) => {
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [employeeId, setEmployeeId] = useState(null);
  const [newFullName, setNewFullName] = useState<string | null>(null);
  const [clear, setClear] = useState(null);
  const [img, setImg] = useState<string | null>(null);
  const [user, setUser] = useState<IUser>({
    name: "",
    email: "",
    username: "",
    allowedModules: [],
    userGroups: [],
    userGroupNames: [],
    password: "",
  });

  const delayedQueryUser = useCallback(
    debounce(async (name, data) => {
      try {
        if (name === "email") {
          authServices.updateCurrentEmail(data);
        }
        if (name !== "email") {
          authServices.updateCurrentUsername(data);
        }
      } catch (err) {
        console.log(err);
      }
    }, 1000),
    []
  );

  const openChangeUserPasswordModal = () => {
    setIsOpen1(true);
    setClickOutsideActive(false);
  };

  const openUploadImageDialog = () => {
    setIsOpen2(true);
    setClickOutsideActive(false);
  };

  const updateNameOrEmployee = useCallback(() => {
    if (employeeId !== null) {
      delayedQueryUser("employee", { employeeId: employeeId });
    }
    if (newFullName !== null) {
      let splitted = newFullName.split(" ");
      let firstN = splitted[0];
      splitted.shift();
      splitted.join(",");
      let fullName = firstN.concat(" ", splitted.toString());
      delayedQueryUser("name", { name: fullName });
    }
    if (clear !== null) {
      delayedQueryUser("clear", { employeeId: null });
    }
  }, [employeeId, newFullName, clear, delayedQueryUser]);

  async function getLogo() {
    try {
      const img = await authServices.getMyProfilePicture();
      setImg(img);
    } catch (error) {
      console.log(error);
    }
  };

  async function getUser() {
    try {
      const user = await authServices.getCurrentUser();
      setUser(user);
    } catch (error) {
      console.log(error);
    }
  };

  function changeEmail(name: string, newEmail: string) {
    if (newEmail !== null) {
      delayedQueryUser(name, { email: newEmail });
    }
    return { ...user, email: newEmail };
  };

  useEffect(() => {
    updateNameOrEmployee();
  }, [employeeId, newFullName, clear, updateNameOrEmployee]);

  useEffect(() => {
    getLogo();
    getUser();
  }, []);

  const refreshLogo = () => {
    getLogo();
  };

  return (
    <>
      <div className="user-container" key={user.username}>
        <div className="user-item item1">
          <img
            src={img ? img : userImage}
            width="100%"
            alt="img"
            onClick={() => openUploadImageDialog()}
          />
        </div>
        <div className="user-item item2">
          <EmployeeSelectCustom
            defaultValue={user.name
              ? user.name
              : (user.employee?.name ? user.employee?.name : "")}
            placeholder="Ime i prezime korisnika"
            setEmployee={setEmployeeId}
            setNewFullName={setNewFullName}
            clearValue={setClear}
            classes="dropdownUser"
          />
        </div>
        <div className="user-item item3">
          <input
            type="text"
            className="settings-input w100 red"
            value={user.username}
            readOnly
          />
        </div>
        <div className="user-item item4">
          <input
            type="text"
            name="email"
            placeholder="Imejl adresa korisnika"
            className="settings-input w100 center"
            style={{ backgroundColor: "white" }}
            value={user.email ? user.email : ""}
            onChange={(e) => setUser(changeEmail("email", e.target.value))}
          />
        </div>
        <div className="user-item item5">
          <input
            type="password"
            style={{ cursor: "pointer" }}
            className="settings-input w100"
            value="12345678"
            readOnly
            onClick={() => {
              openChangeUserPasswordModal();
            }}
          />
        </div>
      </div>
      <UpdateUserPasswordModal
        isOpen={isOpen1}
        useConfirmation={true}
        setIsOpen={setIsOpen1}
        user={user}
        currentUser={user}
        setClickOutsideActive={setClickOutsideActive}
      />
      <UploadPhotoModal
        uploadType={ImageUploadType.MY_LOGO}
        isOpen={isOpen2}
        user={user}
        refresh={refreshLogo}
        setIsOpen={setIsOpen2}
        aspect={1 / 1}
        setClickOutsideActive={setClickOutsideActive}
      />
    </>
  );
};

export default UserSettings;
